import { Button } from '@orbita-ui/core';
import { memo, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { SearchTarjetaRequest } from 'core/tarjeta/models/SearchTarjetaRequest';
import { CuentaSelector } from 'core/cuenta/components/CuentaSelector/CuentaSelector';
import { useForm } from 'react-hook-form';
import { FormWithValidation } from 'shared/form';
import { CentroCostoSelector } from 'core/centrocosto/components/CentroCostoSelector/CentroCostoSelector';

export interface CardsFiltersProps {
  onSearch: (filters: SearchTarjetaRequest) => void;
  initialFilters?: SearchTarjetaRequest;
}

interface CardsFilterFormValue {
  centroCostoAsociadoId: number;
  numeroCuenta: string;
  numeroTarjeta: string;
  denominacionTarjeta: string;
}

const mapFormData = (formData: Partial<CardsFilterFormValue>): SearchTarjetaRequest => {
  return {
    centroCostoOrigenId: formData.centroCostoAsociadoId,
    numeroCuenta: formData.numeroCuenta,
    numeroTarjeta: formData.numeroTarjeta,
    denominacionTarjeta: formData.denominacionTarjeta,
  };
};

const EMPTY_FORM_VALUES = {
  centroCostoAsociadoId: null,
  numeroCuenta: null,
  numeroTarjeta: '',
  denominacionTarjeta: '',
};

export const CardsFiltersForm = memo(function CardsFiltersForm({
  initialFilters,
  onSearch,
}: CardsFiltersProps) {
  const methods = useForm<CardsFilterFormValue>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: EMPTY_FORM_VALUES,
  });

  const handleSearch = (data: CardsFilterFormValue) => {
    onSearch(mapFormData(data));
  };

  useEffect(() => {
    if (initialFilters) {
      // reseteamos el formulario con los valores que vienen de la URL
      methods.reset({
        centroCostoAsociadoId: initialFilters.centroCostoOrigenId || null,
        numeroCuenta: initialFilters.numeroCuenta || null,
        numeroTarjeta: initialFilters.numeroTarjeta || '',
        denominacionTarjeta: initialFilters.denominacionTarjeta || '',
      });
    }
  }, [initialFilters, methods]);

  return (
    <Card>
      <Card.Title>Filtros</Card.Title>
      <Card.Body>
        <FormWithValidation
          reactFormHookMethods={methods}
          onSubmit={handleSearch}
          className="m-3"
        >
          <Row>
            <Col>
              <CentroCostoSelector
                name="centroCostoAsociadoId"
                label="Centro de costos asociado"
              />
            </Col>
            <Col>
              <CuentaSelector name="numeroCuenta" label="Cuenta" />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormWithValidation.TextInput
                name="numeroTarjeta"
                label="Número de tarjeta"
                fullWidth
              />
            </Col>
            <Col>
              <FormWithValidation.TextInput
                name="denominacionTarjeta"
                label="Denominación de la tarjeta"
                fullWidth
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-end" style={{ gap: 8 }}>
            <Button
              type="button"
              variant="outline"
              color="destructive"
              onClick={() => methods.reset(EMPTY_FORM_VALUES)}
            >
              Limpiar
            </Button>
            <Button type="submit">Consultar</Button>
          </div>
        </FormWithValidation>
      </Card.Body>
    </Card>
  );
});
